import SubMeterForm from './SubMeterForm';

const UpdateSubMeter = () => {
    return <SubMeterForm isUpdate={true} />;
};

export default UpdateSubMeter;
